import React, { useEffect, useRef, useState, useMemo } from "react";
import axios from "axios";
import { BASE_URL, IMAGE_URL, TESTING_URL } from "../../config/axios";
import {
    formatDate,
    formatDateTime,
    formattedDate,
    formattedDateLong,
} from "../Date";
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import Calaneder from "../dashboard-comp/Calaneder";
import AttendanceChart from "../UserDetails/userDetails-comp/AttendanceChart";
import LeaveChart from "../UserDetails/userDetails-comp/LeaveChart";
import OutDutyChart from "../UserDetails/userDetails-comp/OdChart";
import {
    ButtonVariants,
    customSortByKey,
    DateRangePicker,
    DoubleMonthRangePicker,
    FormatKey,
    formatRoundoffComplete,
    getNumberSuffix,
    handleErrorToast,
    MonthRangePicker,
    ViewDynamicApprovalRemarks,
    ViewDynamicApprovalStatus,
    ViewFile,
} from "../CustomFunctions";
import {
    CircularGrid,
    DeleteDustbin,
    Filter,
    Refresh,
    SubmitArrowHead,
    SubmitArrowHead1,
    SubmitArrowHead2,
} from "../AllSvg";
import Loader from "../Loader";

const today = new Date();
today.setDate(today.getDate() - 60);

const year = today.getFullYear();
const month = today.getMonth() + 1;
const day = today.getDate();

const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
  .toString()
  .padStart(2, "0")}`;

// ------------------------------------------------------------Attendance & Request Management
const AttendanceDashboard = ({ email, emp_code }) => {
    const today = new Date();
    today.setDate(today.getDate() - 30);

    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const [startdate, setStartDate] = useState(`${formattedDatee}`);
    const [enddate, setEndDate] = useState(`${formattedDate}`);
    const [allattendanceStatus, setAttendanceStatus] = useState({});
    const [leavesData, setLeavesData] = useState({});
    const [graphData, setGraphData] = useState({});

    const [buffer, setBuffering] = useState(true); //buffering logic
    const getAttendanceDetails = async () => {
        setBuffering(true); // Start Buffering
        try {
            const att = await axios.get(
                `${BASE_URL}/wfm/attendancefilterbyEmpByMonthstatusquick/${emp_code}/${startdate}/${enddate}/`,
            );
            setAttendanceStatus(att.data);

            const leave = await axios.get(
                `${BASE_URL}/wfm/leavebalance/${emp_code}/`,
            );
            setLeavesData(leave.data);

            const graph = await axios.get(
                `${BASE_URL}/wfm/requeststatus/${emp_code}/`,
            );
            setGraphData(graph.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getAttendanceDetails();
    }, [startdate, enddate]);

    return (
        <>
            <div className="attendance-top-cont gap-20">
                {/* Replaced inline style with a responsive class */}
                <div className="attendance-column calendar-column">
                    <Calaneder />
                </div>

                {/* Added the responsive class alongside your existing class */}
                <div className="primary-left-chart attendance-column">
                    <AttendanceChart
                        allattendanceStatus={allattendanceStatus}
                        height={240}
                    />
                    {/* <div className="attendance-history-cont desktop-view-calender-history">
                        <div className="attendance-subcontainer newdshbaordattendance-subcontainer">
                            <div className="attendance-heading font-weight500 font-size-heading">
                                Attendance Starts
                            </div>

                            <div className="justify-between flex-row w-full">
                                <div className="attendance-heading font-weight500 font-size-heading width-new-50-percent">
                                    From
                                </div>
                                <div className="attendance-heading  font-weight500    font-size-heading width-new-50-percent">
                                    To
                                </div>



                            </div>
                            <div className="justify-between flex-row w-full">
                                <div className="field-cont-div items-center newfields-cont-div-dashboard">

                                    <input
                                        className="attendance-input-field  date-field"
                                        placeholder="From Date"
                                        type="date"
                                        value={startdate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />

                                </div>

                                <div className="field-cont-div newfields-cont-div-dashboard">

                                    <input
                                        className="attendance-input-field   date-field"
                                        placeholder="To Date"
                                        type="date"
                                        value={enddate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />

                                </div>
                            </div>

                            <div className="btn-cont">

                            </div>
                        </div>
                    </div> */}

                    <div className="attendance-history-cont mobile-view-calender-history">
                        <div className="attendance-subcontainer newdshbaordattendance-subcontainer">
                            <div className="attendance-heading font-weight500 font-size-heading">
                                Attendance Starts
                            </div>

                            <div className="justify-between flex w-full">
                                <div className="attendance-heading font-weight500 font-size-heading width-new-50-percent">
                                    From
                                </div>

                                <div className="field-cont-div items-center newfields-cont-div-dashboard">

                                    <input
                                        className="attendance-input-field  date-field"
                                        placeholder="From Date"
                                        type="date"
                                        value={startdate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />

                                </div>



                            </div>
                            <div className="justify-between flex w-full">

                                <div className="attendance-heading  font-weight500    font-size-heading width-new-50-percent">
                                    To
                                </div>
                                <div className="field-cont-div newfields-cont-div-dashboard">

                                    <input
                                        className="attendance-input-field   date-field"
                                        placeholder="To Date"
                                        type="date"
                                        value={enddate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />

                                </div>
                            </div>

                            <div className="btn-cont">
                                {/* <button className='attendance-btn' onClick={getAttendanceDetails}><img src={Searchicon} alt="Search" className='searchicon' />Search</button> */}
                            </div>
                        </div>
                    </div>


                    <div
                        className="bloc-tabs-with-white-bg"
                        style={{ margin: "0px", flexGrow: "1", padding: "20px" }}
                    >
                        <div className="field-container">
                            <div className="leave-balance-card leave-balance-card-previous">
                                <div className="leave-balance-icon">&#128197;</div>{" "}
                                {/* Calendar icon */}
                                <div className="leave-balance-info">
                                    <span className="leave-balance-label">Previous : </span>
                                    <span className="leave-balance-duration">
                                        {leavesData.leavebalance
                                            ? `${leavesData.leavebalance} ${leavesData.leavebalance > 1 ? "days" : "day"}`
                                            : "0 day"}
                                    </span>
                                </div>
                            </div>

                            <div className="leave-balance-card leave-balance-card-casual">
                                <div className="leave-balance-icon">&#128215;</div>{" "}
                                {/* Notebook icon */}
                                <div className="leave-balance-info">
                                    <span className="leave-balance-label">Casual : </span>
                                    <span className="leave-balance-duration">
                                        {leavesData.casual_leave
                                            ? `${leavesData.casual_leave} ${leavesData.casual_leave > 1 ? "days" : "day"}`
                                            : "0 day"}
                                    </span>
                                </div>
                            </div>

                            <div className="leave-balance-card leave-balance-card-sick">
                                <div className="leave-balance-icon">&#128138;</div>{" "}
                                {/* Sick emoji icon */}
                                <div className="leave-balance-info">
                                    <span className="leave-balance-label">Sick : </span>
                                    <span className="leave-balance-duration">
                                        {leavesData.sick_leave
                                            ? `${leavesData.sick_leave} ${leavesData.sick_leave > 1 ? "days" : "day"}`
                                            : "0 day"}
                                    </span>
                                </div>
                            </div>

                            <div className="leave-balance-card leave-balance-card-earned">
                                <div className="leave-balance-icon">&#127942;</div>{" "}
                                {/* Trophy icon */}
                                <div className="leave-balance-info">
                                    <span className="leave-balance-label">Earned : </span>
                                    <span className="leave-balance-duration">
                                        {leavesData.earn_leave
                                            ? `${leavesData.earn_leave} ${leavesData.earn_leave > 1 ? "days" : "day"}`
                                            : "0 day"}
                                    </span>
                                </div>
                            </div>

                            <div className="leave-balance-card leave-balance-card-short">
                                <div className="leave-balance-icon">⏱️</div>{" "}
                                {/* CLock emoji icon */}
                                <div className="leave-balance-info">
                                    <span className="leave-balance-label">Short Leave : </span>
                                    <span className="leave-balance-duration">
                                        {leavesData.short_leave
                                            ? `${leavesData.short_leave} ${leavesData.short_leave > 1 ? "days" : "day"}`
                                            : "0 day"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="" style={{ width: "100%", padding: "10px 0px 20px 0px" }}>
                <div className="attendance-top-cont">
                    <div className="profile-leave-primary" style={{ flexBasis: "45%" }}>
                        <div className="profile-leave-status">
                            <span className="profile-leave-status-heading">
                                Total Leave Requests
                            </span>
                            <span>{graphData.allleaverequest} </span>
                        </div>
                        <div className="profile-leave-status">
                            <span className="profile-leave-status-heading">
                                Pending Requests
                            </span>
                            <span>{graphData.leave_details_pending} </span>
                        </div>
                        <div className="profile-leave-status">
                            <span className="profile-leave-status-heading">
                                Approved Requests
                            </span>
                            <span>{graphData.leave_details_approved} </span>
                        </div>
                        <div className="profile-leave-status">
                            <span className="profile-leave-status-heading">
                                Rejected Requests
                            </span>
                            <span>{graphData.leave_details_rejected} </span>
                        </div>
                    </div>

                    <div className="profile-leave-secondary" style={{ flexBasis: "50%" }}>
                        <LeaveChart emp_code={emp_code} />
                    </div>
                </div>
            </div>
            <div className="attendance-top-cont gap-2vw">
                <div className="profile-leave-secondary attendance-column" style={{ flexBasis: "50%" }}>
                    <OutDutyChart />
                </div>

                <div className="profile-leave-primary attendance-column" style={{ flexBasis: "45%" }}>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Total OutDuty Requests
                        </span>
                        <span>{graphData.alloutdutyrequest} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Pending Requests
                        </span>
                        <span>{graphData.outduty_details_pending} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Approved Requests
                        </span>
                        <span>{graphData.outduty_details_approved} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Rejected Requests
                        </span>
                        <span>{graphData.outduty_details_rejected} </span>
                    </div>
                </div>
            </div> */}
            {/* I kept your vertical padding here, but removed the unnecessary width: "100%" */}
            <div
                className="attendance-top-cont gap-20"
                style={{ margin: "20px 0px" }}
            >
                {/* Added attendance-column, removed style={{ flexBasis: "45%" }} */}
                <div className="profile-leave-primary attendance-column">
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Total Leave Requests
                        </span>
                        <span>{graphData.allleaverequest} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Pending Requests
                        </span>
                        <span>{graphData.leave_details_pending} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Approved Requests
                        </span>
                        <span>{graphData.leave_details_approved} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Rejected Requests
                        </span>
                        <span>{graphData.leave_details_rejected} </span>
                    </div>
                </div>

                {/* Added attendance-column, removed style={{ flexBasis: "50%" }} */}
                <div className="profile-leave-secondary attendance-column">
                    <LeaveChart emp_code={emp_code} />
                </div>
            </div>

            {/* Removed inline style={{ display: "flex" }} as attendance-top-cont already does this */}
            <div className="attendance-top-cont gap-20">
                {/* Added attendance-column, removed style={{ flexBasis: "50%" }} */}
                <div className="profile-leave-secondary attendance-column">
                    <OutDutyChart />
                </div>

                {/* Added attendance-column, removed style={{ flexBasis: "45%" }} */}
                <div className="profile-leave-primary attendance-column">
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Total OutDuty Requests
                        </span>
                        <span>{graphData.alloutdutyrequest} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Pending Requests
                        </span>
                        <span>{graphData.outduty_details_pending} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Approved Requests
                        </span>
                        <span>{graphData.outduty_details_approved} </span>
                    </div>
                    <div className="profile-leave-status">
                        <span className="profile-leave-status-heading">
                            Rejected Requests
                        </span>
                        <span>{graphData.outduty_details_rejected} </span>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

// const EmployeeDetailsChangeTimeline = ({ emp_code }) => {
//     const [buffer, setBuffering] = useState(true);
//     const [fromdate, setFromDate] = useState("");
//     const [todate, setToDate] = useState("");
//     const [selectedDivision, setDivision] = useState(
//         `${sessionStorage.getItem("company_id")}`,
//     );
//     const [changeLogList, setChangeLogList] = useState([]);
//     const [selectedChange, setSelectedChange] = useState(null);
//     const [showModal, setShowModal] = useState(false);

//     const getChangeLogList = async () => {
//         setBuffering(true);
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/employee_journey_details/${emp_code}/`,
//             );
//             setChangeLogList(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);
//         }
//     };

//     useEffect(() => {
//         getChangeLogList();
//     }, [emp_code, fromdate, todate, selectedDivision]);

//     const findDifferences = (before, after) => {
//         if (!before || !after) return {};

//         const differences = {};
//         Object.keys(after).forEach((key) => {
//             if (JSON.stringify(before[key]) !== JSON.stringify(after[key])) {
//                 differences[key] = {
//                     before: before[key],
//                     after: after[key],
//                 };
//             }
//         });
//         return differences;
//     };

//     const openChangeDetails = (log) => {
//         const changes =
//             log.changed_fields ||
//             findDifferences(log.previous_data, log.updated_data);
//         setSelectedChange({
//             ...log,
//             computedChanges: changes,
//         });
//         setShowModal(true);
//     };

//     const renderTimelineItem = (log, index) => {
//         const changes =
//             log.changed_fields ||
//             findDifferences(log.previous_data, log.updated_data);
//         const changeCount = Object.keys(changes).length;
//         const changedFields = Object.keys(changes).map((field) =>
//             field.replace(/_/g, " "),
//         );

//         return (
//             <>
//                 <div
//                     key={log.id}
//                     className="emp_data_timeline_item"
//                     onClick={() => openChangeDetails(log)}
//                 >
//                     <div className="emp_data_timeline_dot"></div>
//                     <div className="emp_data_timeline_content flex-row justify-between">
//                         <div style={{ width: "50%" }}>
//                             <div className="emp_data_timeline_date">
//                                 {formatDateTime(log.updated_at).longdate}
//                             </div>
//                             <div className="emp_data_timeline_updatedby">
//                                 Updated by: {log.updated_by}
//                             </div>
//                         </div>
//                         <div style={{ width: "50%" }}>
//                             <div className="emp_data_timeline_changes">
//                                 {changeCount > 0 ? (
//                                     <>
//                                         <div className="emp_data_timeline_change_count">
//                                             {changeCount} field{changeCount > 1 ? "s" : ""} changed
//                                         </div>
//                                         <div className="emp_data_timeline_change_fields">
//                                             {changedFields.join(", ")}
//                                         </div>
//                                     </>
//                                 ) : (
//                                     "No changes detected"
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </>
//         );
//     };

//     const renderDiffValue = (value) => {
//         if (value === null || value === undefined) return "null";
//         if (typeof value === "object") return JSON.stringify(value);
//         return value.toString();
//     };

//     const leftColumnRef = useRef(null);
//     const rightColumnRef = useRef(null);

//     const handleScroll = (e) => {
//         if (e.target === leftColumnRef.current) {
//             rightColumnRef.current.scrollTop = e.target.scrollTop;
//         } else if (e.target === rightColumnRef.current) {
//             leftColumnRef.current.scrollTop = e.target.scrollTop;
//         }
//     };
//     return (
//         <>
//             <div className="table-css-white-background">
//                 <div className="emp_data_timeline_header">
//                     <h5 className="emp_data_timeline_title">
//                         Employee Organization Details Change History
//                     </h5>
//                     {/* <DateRangePicker
//                         startDate={fromdate}
//                         endDate={todate}
//                         placeHolder1="From Date"
//                         placeHolder2="To Date"
//                         onChange={(start, end) => {
//                             setFromDate(start);
//                             setToDate(end);
//                         }} /> */}
//                 </div>

//                 {buffer ? (
//                     <Loader container={true} />
//                 ) : (
//                     // <div className="emp_data_timeline_wrapper">
//                     //     {changeLogList.length > 0 ? (
//                     //         changeLogList
//                     //             .filter(log => {
//                     //                 const logDate = new Date(log.updated_at).toISOString().slice(0, 10); // format: 'YYYY-MM-DD'
//                     //                 return (!fromdate || logDate >= fromdate) && (!todate || logDate <= todate);
//                     //             })
//                     //             .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
//                     //             .map((log, index) => renderTimelineItem(log, index))
//                     //     ) : (
//                     //         <div className="emp_data_timeline_empty">No change history found</div>
//                     //     )}
//                     // </div>
//                     <div className="emp_data_timeline_wrapper">
//                         {changeLogList
//                             .filter((log) => {
//                                 const logDate = new Date(log.updated_at)
//                                     .toISOString()
//                                     .slice(0, 10); // format: 'YYYY-MM-DD'
//                                 return (
//                                     (!fromdate || logDate >= fromdate) &&
//                                     (!todate || logDate <= todate)
//                                 );
//                             })
//                             .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
//                             .map((log, index) => renderTimelineItem(log, index))}
//                         {changeLogList.filter((log) => {
//                             const logDate = new Date(log.updated_at)
//                                 .toISOString()
//                                 .slice(0, 10);
//                             return (
//                                 (!fromdate || logDate >= fromdate) &&
//                                 (!todate || logDate <= todate)
//                             );
//                         }).length === 0 && (
//                                 <div className="emp_data_timeline_empty">
//                                     No change history found
//                                 </div>
//                             )}
//                     </div>
//                 )}
//             </div>
//             <ToastContainer
//                 position="top-center"
//                 autoClose={1000}
//                 hideProgressBar={false}
//                 newestOnTop={true}
//                 closeOnClick
//                 rtl={false}
//                 pauseOnFocusLoss
//                 draggable
//                 pauseOnHover
//             />

//             {showModal && selectedChange && (
//                 <div className="emp_data_timeline_modal">
//                     <div
//                         className="emp_data_timeline_modal_overlay"
//                         onClick={() => setShowModal(false)}
//                     ></div>
//                     <div className="emp_data_timeline_modal_content">
//                         <div className="emp_data_timeline_modal_header">
//                             <h3>
//                                 Change Details -{" "}
//                                 {formatDateTime(selectedChange.updated_at).date}
//                             </h3>
//                             <button
//                                 className="emp_data_timeline_modal_close"
//                                 onClick={() => setShowModal(false)}
//                             >
//                                 &times;
//                             </button>
//                         </div>
//                         <div
//                             className="emp_data_timeline_modal_body"
//                             onScroll={handleScroll}
//                         >
//                             <div
//                                 className="emp_data_timeline_modal_column"
//                                 ref={leftColumnRef}
//                                 onScroll={handleScroll}
//                             >
//                                 <h4>Before</h4>
//                                 {Object.entries(selectedChange.previous_data || {}).map(
//                                     ([key, value]) => (
//                                         <div
//                                             key={`before-${key}`}
//                                             className={`emp_data_timeline_modal_row ${selectedChange.computedChanges[key]
//                                                 ? "emp_data_timeline_modal_changed"
//                                                 : ""
//                                                 }`}
//                                         >
//                                             <strong>{key.replace(/_/g, " ")}:</strong>{" "}
//                                             {renderDiffValue(value)}
//                                         </div>
//                                     ),
//                                 )}
//                             </div>
//                             <div
//                                 className="emp_data_timeline_modal_column"
//                                 ref={rightColumnRef}
//                                 onScroll={handleScroll}
//                             >
//                                 <h4>After</h4>
//                                 {Object.entries(selectedChange.updated_data || {}).map(
//                                     ([key, value]) => (
//                                         <div
//                                             key={`after-${key}`}
//                                             className={`emp_data_timeline_modal_row ${selectedChange.computedChanges[key]
//                                                 ? "emp_data_timeline_modal_changed"
//                                                 : ""
//                                                 }`}
//                                         >
//                                             <strong>{key.replace(/_/g, " ")}:</strong>{" "}
//                                             {renderDiffValue(value)}
//                                         </div>
//                                     ),
//                                 )}
//                             </div>
//                         </div>
//                         <div className="emp_data_timeline_modal_footer">
//                             <button
//                                 className="emp_data_timeline_modal_button"
//                                 onClick={() => setShowModal(false)}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

const EmployeeDetailsChangeTimeline = ({ emp_code }) => {
 
    const [buffer, setBuffering] = useState(true);
    const [startdate, setStartDate] = useState(`${formattedDatee}`);
    const [enddate, setEndDate] = useState(`${formattedDate}`);
    const [changeLogList, setChangeLogList] = useState([]);
    const [selectedChange, setSelectedChange] = useState(null);
    const [showModal, setShowModal] = useState(false);
 
    const leftColumnRef = useRef(null);
    const rightColumnRef = useRef(null);
 
    // ---------- Change log API ----------
    useEffect(() => {
        if (!emp_code) return;
        const controller = new AbortController(); // ignore stale responses
 
        (async () => {
            setBuffering(true);
            try {
                const params = { emp_code };
                if (startdate) params.start_date = startdate;
                if (enddate) params.end_date = enddate;
 
                const res = await axios.get(
                    `${BASE_URL}/wfm/employee_journey_details_filter/`,
                    { params, signal: controller.signal },
                );
                setChangeLogList(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                if (axios.isCancel(err) || err.name === "CanceledError") return;
                setChangeLogList([]);
                handleErrorToast(err);
            } finally {
                if (!controller.signal.aborted) setBuffering(false);
            }
        })();
 
        return () => controller.abort();
    }, [emp_code, startdate, enddate]);
 
    // ---------- helpers ----------
    const findDifferences = (before, after) => {
        if (!before || !after) return {};
        const differences = {};
        Object.keys(after).forEach((key) => {
            if (JSON.stringify(before[key]) !== JSON.stringify(after[key])) {
                differences[key] = { before: before[key], after: after[key] };
            }
        });
        return differences;
    };
 
    const getChanges = (log) =>
        log.changed_fields || findDifferences(log.previous_data, log.updated_data);
 
    // server already filters by date / sub_company; we only sort newest first
    const sortedLogs = useMemo(
        () =>
            [...changeLogList].sort(
                (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
            ),
        [changeLogList],
    );
 
    const openChangeDetails = (log) => {
        setSelectedChange({ ...log, computedChanges: getChanges(log) });
        setShowModal(true);
    };
 
    const renderDiffValue = (value) => {
        if (value === null || value === undefined) return "null";
        if (typeof value === "object") return JSON.stringify(value);
        return value.toString();
    };
 
    const handleScroll = (e) => {
        if (e.target === leftColumnRef.current && rightColumnRef.current) {
            rightColumnRef.current.scrollTop = e.target.scrollTop;
        } else if (e.target === rightColumnRef.current && leftColumnRef.current) {
            leftColumnRef.current.scrollTop = e.target.scrollTop;
        }
    };
 
    const renderTimelineItem = (log) => {
        const changes = getChanges(log);
        const changeCount = Object.keys(changes).length;
        const changedFields = Object.keys(changes).map((f) => f.replace(/_/g, " "));
 
        return (
            <div
                key={log.id}
                className="emp_data_timeline_item"
                onClick={() => openChangeDetails(log)}
            >
                <div className="emp_data_timeline_dot"></div>
                <div className="emp_data_timeline_content flex-row justify-between">
                    <div style={{ width: "50%" }}>
                        <div className="emp_data_timeline_date">
                            {formatDateTime(log.updated_at).longdate}
                        </div>
                        <div className="emp_data_timeline_updatedby">
                            Updated by: {log.updated_by}
                        </div>
                    </div>
                    <div style={{ width: "50%" }}>
                        <div className="emp_data_timeline_changes">
                            {changeCount > 0 ? (
                                <>
                                    <div className="emp_data_timeline_change_count">
                                        {changeCount} field{changeCount > 1 ? "s" : ""} changed
                                    </div>
                                    <div className="emp_data_timeline_change_fields">
                                        {changedFields.join(", ")}
                                    </div>
                                </>
                            ) : (
                                "No changes detected"
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };
 
    const renderColumn = (title, data, ref, prefix) => (
        <div
            className="emp_data_timeline_modal_column"
            ref={ref}
            onScroll={handleScroll}
        >
            <h4>{title}</h4>
            {Object.entries(data || {}).map(([key, value]) => (
                <div
                    key={`${prefix}-${key}`}
                    className={`emp_data_timeline_modal_row ${
                        selectedChange.computedChanges[key]
                            ? "emp_data_timeline_modal_changed"
                            : ""
                    }`}
                >
                    <strong>{key.replace(/_/g, " ")}:</strong> {renderDiffValue(value)}
                </div>
            ))}
        </div>
    );
 
    // ---------- render ----------
    return (
        <>
            <div className="table-css-white-background">
                <div
                    className="emp_data_timeline_header"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "8px",
                    }}
                >
                    <h5 className="emp_data_timeline_title">
                        Employee Organization Details Change History
                    </h5>
 
                    {/* date range */}
                    <div className="field-cont" style={{ width: "auto" }}>
                        <div title="Date Range" className="field-cont-div">
                            <DateRangePicker
                                startDate={startdate}
                                endDate={enddate}
                                placeHolder1="From Date"
                                placeHolder2="To Date"
                                onChange={(start, end) => {
                                    setStartDate(start || "null");
                                    setEndDate(end || "null");
                                }}
                            />
                        </div>
                    </div>
                </div>
 
                {buffer ? (
                    <Loader container={true} />
                ) : (
                    <div className="emp_data_timeline_wrapper">
                        {sortedLogs.length > 0 ? (
                            sortedLogs.map(renderTimelineItem)
                        ) : (
                            <div className="emp_data_timeline_empty">
                                No change history found
                            </div>
                        )}
                    </div>
                )}
            </div>
 
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
 
            {showModal && selectedChange && (
                <div className="emp_data_timeline_modal">
                    <div
                        className="emp_data_timeline_modal_overlay"
                        onClick={() => setShowModal(false)}
                    ></div>
                    <div className="emp_data_timeline_modal_content">
                        <div className="emp_data_timeline_modal_header">
                            <h3>
                                Change Details - {formatDateTime(selectedChange.updated_at).date}
                            </h3>
                            <button
                                className="emp_data_timeline_modal_close"
                                onClick={() => setShowModal(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="emp_data_timeline_modal_body">
                            {renderColumn("Before", selectedChange.previous_data, leftColumnRef, "before")}
                            {renderColumn("After", selectedChange.updated_data, rightColumnRef, "after")}
                        </div>
                        <div className="emp_data_timeline_modal_footer">
                            <button
                                className="emp_data_timeline_modal_button"
                                onClick={() => setShowModal(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const BankDetailChangeLogDelete = ({
    empcode,
    id,
    getBankDetailsChangeLogs,
}) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(`${BASE_URL}/wfm/bank-details-log/${id}/`);
            if (res.status === 200) {
                await getBankDetailsChangeLogs();
                setShow(false);
                toast.success(id && "Bank Details Deleted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Bank Detail of "
                        <span className="font-weight500">{empcode}</span>"{" "}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Delete Bank Details of <b>{empcode}</b>
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

function dependencySort(data) {
    const idToEntry = Object.fromEntries(data.map((entry) => [entry.id, entry]));
    const adjacencyList = {};
    const inDegree = {};

    data.forEach((entry) => {
        const id = entry.id;
        inDegree[id] = 0;
        adjacencyList[id] = [];
    });

    data.forEach((entry) => {
        entry.percentage_of?.forEach((dep) => {
            if (adjacencyList[dep.id]) {
                adjacencyList[dep.id].push(entry.id);
                inDegree[entry.id]++;
            }
        });
    });

    const queue = Object.keys(inDegree).filter((id) => inDegree[id] === 0);
    const sorted = [];

    while (queue.length) {
        const current = queue.shift();
        sorted.push(idToEntry[current]);

        adjacencyList[current].forEach((depId) => {
            inDegree[depId]--;
            if (inDegree[depId] === 0) queue.push(depId);
        });
    }

    const remaining = Object.keys(inDegree).filter((id) => inDegree[id] > 0);
    if (remaining.length) {
        console.warn(
            "Circular dependency detected. Adding remaining unsorted items at the end.",
        );
        remaining.forEach((id) => sorted.push(idToEntry[id]));
    }

    return sorted;
}

function getCalculatedAmount(entry, data, visited = new Set()) {
    if (visited.has(entry.id)) {
        return {
            value: 0,
            explanation: `[Cycle detected for ${entry.name_title}]`,
        };
    }

    visited.add(entry.id);

    if (entry.fixed_amount) {
        const amount = parseFloat(entry.fixed_amount);
        return {
            value: amount,
            explanation: `${entry.name_title}: fixed amount = ${amount}`,
        };
    }

    if (entry.percentage && entry.percentage_of?.length > 0) {
        const percentage = parseFloat(entry.percentage);
        const components = [];

        const values = entry.percentage_of.map((refItem) => {
            const targetEntry = data.find(
                (i) =>
                    i.id === refItem.name_id ||
                    i.name_id === refItem.name_id ||
                    i.name_title === refItem.name_title,
                // ||
                // i.id === refItem.id ||
                // i.name === refItem.id ||
                // i.name === refItem.name ||
                // i.id === refItem.name
            );

            if (!targetEntry) {
                components.push(`Unknown ref: ${refItem.name || refItem.id}`);
                return 0;
            }

            const { value, explanation } = getCalculatedAmount(
                targetEntry,
                data,
                new Set(visited),
            );
            components.push(`${targetEntry.name_title}: ${value}`);
            return value;
        });

        let baseTotal = 0;
        let breakdown = "";

        if (entry.name_type === "difference") {
            const sorted = [...values].sort((a, b) => b - a); // Descending order
            const max = sorted[0];
            const restSum = sorted.slice(1).reduce((sum, v) => sum + v, 0);
            baseTotal = Math.max(0, max - restSum); // Ensure non-negative
            breakdown = `Max (${max}) - Sum of rest (${restSum}) = ${baseTotal}`;
        } else {
            baseTotal = values.reduce((sum, v) => sum + v, 0);
            breakdown = `Sum = ₹${baseTotal}`;
        }

        const result = (percentage / 100) * baseTotal;
        const explanation = `${entry.name_title} = (${percentage}%) of [${components.join(", ")}] \n→ ${breakdown} \n→ Final = ${result.toFixed(2)}`;

        return {
            value: result,
            explanation,
        };
    }

    return {
        value: 0,
        explanation: `${entry.name_title}: No fixed or percentage defined`,
    };
}

const renderAmount = (item) => {
    if (!item) return "-";

    const amount = item.calculated_amount ?? 0;

    return (
        <span className="salary-history-amount">₹{Number(amount).toFixed(2)}</span>
    );
};

// ---------------------------
// 1. Salary Structure Table Component (Reusable)
// ---------------------------
const SalaryStructureTable = ({
    salaryData,
    title = "Salary Structure",
    content_type = "full",
    sortingVarBY = true,
    roundOffAmount = false,
    scrollRef,
    handleScroll,
    rowStatusMap = null,
    tableSide = null, // "before" | "after"
}) => {
    // content_type = "less"/"full"

    let sortedData = salaryData;
    if (sortingVarBY) {
        sortedData = [...salaryData].sort(
            (a, b) => a.name_sorting_var - b.name_sorting_var,
        );
    } else if (salaryData.every((item) => item.sorting_var !== null)) {
        sortedData = [...salaryData].sort((a, b) => a.sorting_var - b.sorting_var);
    } else {
        sortedData = dependencySort(salaryData);
    }
    return (
        // <div className="salary-history-table-container">
        // <div className="scroll-container-table" style={{ height: '70vh', overflowY: 'auto' }}>
        <div
            className="scroll-container-table"
            style={{ height: "70vh", overflowY: "auto" }}
            ref={scrollRef}
            onScroll={handleScroll}
        >
            {/* {title && <h4 className="salary-history-table-title">{title}</h4>} */}
            <table className="salary-history-table">
                {/* <table className="scrollfix-table-css"> */}
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left" style={{ width: "0.5vw" }}>
                            Sr. No.(Position)
                        </th>
                        <th className="align-left width-5vw">Heading</th>
                        <th className="align-center width-5vw">Type</th>
                        {content_type === "less" ? (
                            <th colSpan={2} className="align-center width-5vw">
                                Amount Basis
                            </th>
                        ) : (
                            <>
                                <th className="align-right width-5vw">Amount</th>
                                <th className="align-center" style={{ width: "0.5vw" }}>
                                    OR
                                </th>
                                <th className="align-center width-5vw">Percentage</th>
                                {/* <th className="align-center" style={{ width: '0.5vw' }}></th> */}
                                <th className="align-center width-5vw text-left">Related To</th>
                            </>
                        )}
                        <th className="align-right width-5vw">Actual Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedData && sortedData.length > 0 ? (
                        sortedData.map((entry, index) => {
                            const key = entry.name_title || entry.name_id;

                            // Safely resolve status only if rowStatusMap is provided
                            const status = rowStatusMap?.[key] ?? null;

                            // Apply highlights only when comparison context exists
                            const isComparison = !!rowStatusMap && !!tableSide;

                            const isCreated =
                                isComparison && status === "created" && tableSide === "after";
                            const isDeleted =
                                isComparison && status === "deleted" && tableSide === "before";
                            const isUpdated = isComparison && status === "updated";

                            const rowClass = isCreated
                                ? "color-bg-success-light"
                                : isDeleted
                                    ? "color-bg-danger-light"
                                    : isUpdated
                                        ? "color-bg-warning-light"
                                        : "";
                            return (
                                <tr
                                    className={`custom-table-head-td request-status ${rowClass}`}
                                    request-status={entry.salary_is_final ? "approved" : ""}
                                    key={entry.id || index}
                                >
                                    <td
                                        className="align-left"
                                        style={{ cursor: "help" }}
                                        title={` Sorting Var : ${entry.name_sorting_var || entry.sorting_var}${getNumberSuffix(entry.name_sorting_var || entry.sorting_var || 0)} `}
                                    >
                                        {index + 1}({entry.name_sorting_var || entry.sorting_var})
                                    </td>
                                    <td className="align-left">{entry.name_title}</td>
                                    <td className="align-center text-capitalize">
                                        {entry.name_type}
                                    </td>
                                    {content_type == "less" ? (
                                        <>
                                            {entry.fixed_amount && (
                                                <td colSpan={2} className="align-center">
                                                    {entry.fixed_amount || "-"}
                                                </td>
                                            )}
                                            {entry.percentage && (
                                                <>
                                                    <td className="align-center">
                                                        {entry.percentage
                                                            ? `${parseFloat(entry.percentage) % 1 === 0
                                                                ? parseFloat(entry.percentage).toFixed(0)
                                                                : parseFloat(entry.percentage).toFixed(2)
                                                            }%`
                                                            : "-"}
                                                    </td>
                                                    <td className="align-leftt width-10vw">
                                                        {entry.percentage_of.length === 0 ? (
                                                            <div className="align-center">-</div>
                                                        ) : (
                                                            <ul style={{ paddingLeft: "0" }}>
                                                                {entry.percentage_of.map((data, idx) => (
                                                                    <li key={idx}>
                                                                        <span className="text-capitalize">
                                                                            {data.name_title || data.name || "N/A"}
                                                                        </span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </td>
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <td className="align-center">
                                                {entry.fixed_amount || "-"}
                                            </td>
                                            <td className="align-center">
                                                <div
                                                    style={{ width: "1vw" }}
                                                    className="align-center width-5vw"
                                                >
                                                    OR
                                                </div>
                                            </td>
                                            <td className="align-center">
                                                {entry.percentage
                                                    ? `${parseFloat(entry.percentage) % 1 === 0
                                                        ? parseFloat(entry.percentage).toFixed(0)
                                                        : parseFloat(entry.percentage).toFixed(2)
                                                    }%`
                                                    : "-"}
                                            </td>
                                            {/* <th className="align-center" style={{ width: '0.5vw' }}></th> */}
                                            <td className="align-leftt width-10vw">
                                                {entry.percentage_of.length === 0 ? (
                                                    <div className="align-center">-</div>
                                                ) : (
                                                    <ul style={{ paddingLeft: "0" }}>
                                                        {entry.percentage_of.map((data, idx) => (
                                                            <li key={idx}>
                                                                <span className="text-capitalize">
                                                                    {data.name_title || data.name || "N/A"}
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </td>
                                        </>
                                    )}
                                    <td
                                        className="salary-history-amount-cell align-right salary-history-amount-cell"
                                        style={{ cursor: "help" }}
                                        title={`Calculations:\n${getCalculatedAmount(entry, sortedData).explanation}`}
                                    >
                                        {roundOffAmount
                                            ? formatRoundoffComplete(
                                                getCalculatedAmount(entry, sortedData).value || 0,
                                            )
                                            : getCalculatedAmount(entry, sortedData).value.toFixed(2)}
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="8" className="salary-history-no-data">
                                No salary data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

// ---------------------------
// 2. Salary Details Modal Component
// ---------------------------
const SalaryDetailsModal = ({ salaryData, effectivePeriod }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    if (!salaryData) return null;

    return (
        <>
            <button
                className="priority-button color-button-success"
                // className="model-button-small model-button-success"
                onClick={handleShow}
            >
                View Salary
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="three-fourth-modal"
            // className="salary-history-modal"
            >
                {/* <div className="salary-history-modal-overlay" onClick={handleClose}></div> */}
                {/* <div className="salary-history-modal-content"> */}

                <Modal.Header closeButton>
                    <Modal.Title>Salary Details : {effectivePeriod}</Modal.Title>
                </Modal.Header>
                <div className="salary-history-modal-body">
                    <SalaryStructureTable
                        salaryData={salaryData}
                        title={`Salary Structure for ${effectivePeriod}`}
                    />
                </div>
                {/* <div className="salary-history-modal-footer">
                            <button
                                className="salary-history-btn salary-history-btn-close"
                                onClick={handleClose}
                            >
                                Close
                            </button>
                        </div> */}
                {/* </div> */}
            </Modal>
        </>
    );
};

// ---------------------------
// 3. Change Details Modal Component
// ---------------------------
const ChangeDetailsModal = ({ changeData, effectivePeriod, index }) => {
    const [show, setShow] = useState(false);
    const [selectedChangeIndex, setSelectedChangeIndex] = useState(null);

    const handleClose = () => {
        setShow(false);
        setSelectedChangeIndex(null);
    };
    const handleShow = () => setShow(true);

    if (!changeData) return null;

    const handleCompareClick = (index) => {
        setSelectedChangeIndex(index);
    };

    const renderChangeItem = (change, idx) => {
        const isLastChange = idx === 0;
        const version = change.version || 0;

        return (
            <div
                key={change.change_date || idx}
                className="salary-history-change-card"
                style={{
                    position: "relative",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "25px 20px 20px 20px",
                    marginBottom: "30px",
                    background: "#f9f9f9",
                    overflow: "visible",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: "-20px", // Half outside (-20px), half inside
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 10,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "40px",
                            background: "white",
                            padding: "0px 10px",
                            fontWeight: "600",
                            border: "3px solid white",
                            borderRadius: "16px",
                            // boxShadow: '0 3px 6px rgba(52, 152, 219, 0.3)',
                            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
                        }}
                    >
                        {/* {idx || 0}{getNumberSuffix(change.version || 0)} Change */}
                        {/* {change.version || 0}{getNumberSuffix(change.version || 0)} Change */}
                        {isLastChange ? (
                            <>
                                Last ({version}
                                {getNumberSuffix(version)}) Change
                            </>
                        ) : (
                            <>
                                {version}
                                {getNumberSuffix(version)} Change
                            </>
                        )}
                    </div>
                </div>
                {/* <div className="salary-history-change-badge">
                    <span className="salary-history-change-badge-number">
                        {change.version || 1}
                    </span>
                </div> */}
                <div className="salary-history-change-header">
                    <div>
                        <div className="salary-history-change-by">
                            <strong>Last Update:</strong>{" "}
                            {change.updated_by_name || change.updated_by || "Unknown"}
                        </div>
                        <div className="salary-history-change-title">
                            {/* <strong>Change {change.version || 1} at </strong> */}
                            <span className="salary-history-change-date">
                                {formatDate(change.change_date, true).longdatetime}
                            </span>
                        </div>
                    </div>
                    {change.before_data && change.after_data && (
                        <button
                            // className="salary-history-btn salary-history-btn-compare"
                            className="priority-button color-button-warning"
                            onClick={() => handleCompareClick(idx)}
                        >
                            View Comparison
                        </button>
                    )}
                    {/* <div className="salary-history-change-reason">
                        <strong>Reason:</strong> {change.change_reason || 'No reason provided'}
                    </div> */}
                </div>

                <div className="salary-history-change-details">
                    <h5 className="salary-history-section-title">Change Details:</h5>
                    <p className="salary-history-change-description">
                        {change.change_details || "No detailed description"}
                    </p>
                </div>

                <div className="salary-history-change-details">
                    <h5 className="salary-history-section-title">Change Reason:</h5>
                    <p className="salary-history-change-description">
                        {change.change_reason || "No detailed reason"}
                    </p>
                </div>

                <div className="salary-history-changed-fields">
                    <h5 className="salary-history-section-title">
                        Changed Fields ({change.changed_fields?.length || 0}):
                    </h5>
                    {change.changed_fields && change.changed_fields.length > 0 ? (
                        <div className="salary-history-fields-grid">
                            {change.changed_fields
                                .sort((a, b) => a.sorting_var - b.sorting_var)
                                .map((field, fieldIdx) => (
                                    <div key={fieldIdx} className="salary-history-field-item">
                                        <div className="salary-history-field-name">
                                            {field.name}
                                        </div>
                                        <div className="salary-history-field-action">
                                            <span
                                                className={`salary-history-action-badge salary-history-action-${field.action}`}
                                            >
                                                {field.action}
                                            </span>
                                        </div>
                                        <div className="salary-history-field-details">
                                            {field.details}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    ) : (
                        <p className="salary-history-no-fields">
                            No specific field changes recorded
                        </p>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <button
                className="priority-button color-button-submit"
                onClick={handleShow}
            >
                View Changes ({changeData.length})
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="five-sixth-modal"
            >
                {/* <div className="salary-history-modal-overlay" onClick={handleClose}></div> */}
                {/* <div className="salary-history-modal-content salary-history-wide-modal"> */}
                {/* <div className="salary-history-modal-header">
                        <h3 className="salary-history-modal-title">Change History for {effectivePeriod}</h3>
                        <button
                            className="salary-history-modal-close"
                            onClick={handleClose}
                        >
                            &times;
                        </button>
                    </div> */}
                <Modal.Header closeButton>
                    <Modal.Title>Change History for {effectivePeriod}</Modal.Title>
                </Modal.Header>
                <div className="salary-history-modal-body salary-history-changes-body">
                    <div className="salary-history-changes-container">
                        {changeData.length > 0 ? (
                            <>
                                {changeData
                                    // .sort((a, b) => new Date(a.updated_at) - new Date(b.updated_at))
                                    .sort((a, b) => b.version - a.version)
                                    .map(renderChangeItem)}
                                {selectedChangeIndex !== null && (
                                    <ComparisonModal
                                        beforeData={changeData[selectedChangeIndex].before_data}
                                        afterData={changeData[selectedChangeIndex].after_data}
                                        changeInfo={changeData[selectedChangeIndex]}
                                        onClose={() => setSelectedChangeIndex(null)}
                                    />
                                )}
                            </>
                        ) : (
                            <div className="salary-history-no-changes">
                                No changes recorded for this period
                            </div>
                        )}
                    </div>
                </div>
                {/* <div className="salary-history-modal-footer">
                            <button
                                className="salary-history-btn salary-history-btn-close"
                                onClick={handleClose}
                            >
                                Close
                            </button>
                        </div> */}
                {/* </div> */}
            </Modal>
        </>
    );
};

// ---------------------------
// 4. Comparison Modal Component
// ---------------------------

const ComparisonModal = ({ beforeData, afterData, changeInfo, onClose }) => {
    const [show, setShow] = useState(true);

    const handleClose = () => {
        setShow(false);
        onClose && onClose();
    };

    const leftColumnRef = useRef(null);
    const rightColumnRef = useRef(null);

    const handleScroll = (e) => {
        if (e.target === leftColumnRef.current) {
            rightColumnRef.current.scrollTop = e.target.scrollTop;
        } else if (e.target === rightColumnRef.current) {
            leftColumnRef.current.scrollTop = e.target.scrollTop;
        }
    };

    const findDifferences = (before, after) => {
        if (!before || !after) return {};

        const differences = {};
        const allKeys = new Set([
            ...before
                .sort((a, b) => a.sorting_var - b.sorting_var)
                .map((item) => item.name_title || item.name_id),
            ...after
                .sort((a, b) => a.sorting_var - b.sorting_var)
                .map((item) => item.name_title || item.name_id),
        ]);

        const isInChangedFields = (key) => {
            return (
                changeInfo?.changed_fields?.some(
                    (field) => field.name_id === key || field.name === key,
                ) || false
            );
        };

        const areValuesEqual = (val1, val2) => {
            // If both are numbers, compare numeric values
            const num1 = parseFloat(val1);
            const num2 = parseFloat(val2);

            const isNum1Valid = !isNaN(num1) && isFinite(num1);
            const isNum2Valid = !isNaN(num2) && isFinite(num2);

            if (isNum1Valid && isNum2Valid) {
                const tolerance = 0.000001; // 6 decimal places tolerance
                return Math.abs(num1 - num2) < tolerance;
            }

            // For strings, normalize and compare
            if (typeof val1 === "string" && typeof val2 === "string") {
                const normalizeString = (str) => {
                    const num = parseFloat(str);
                    if (!isNaN(num) && isFinite(num)) {
                        return num.toString();
                    }
                    return str.trim();
                };
                return normalizeString(val1) === normalizeString(val2);
            }

            // For other cases, use strict equality
            return val1 === val2;
        };

        // Helper function to compare objects ignoring formatting differences
        const areObjectsEqual = (obj1, obj2) => {
            if (!obj1 || !obj2) return false;

            // Compare key numeric values
            const keysToCompare = ["fixed_amount", "percentage", "calculated_amount"];

            for (const key of keysToCompare) {
                const val1 = obj1[key];
                const val2 = obj2[key];

                if (val1 !== undefined || val2 !== undefined) {
                    if (!areValuesEqual(val1, val2)) {
                        return false;
                    }
                }
            }

            // Compare name_type and name_title
            if (obj1.name_type !== obj2.name_type) return false;
            if (obj1.name_title !== obj2.name_title) return false;

            // Compare percentage_of arrays
            const percentageOf1 = obj1.percentage_of || [];
            const percentageOf2 = obj2.percentage_of || [];

            if (percentageOf1.length !== percentageOf2.length) return false;

            for (let i = 0; i < percentageOf1.length; i++) {
                if (percentageOf1[i].name_title !== percentageOf2[i].name_title) {
                    return false;
                }
            }

            return true;
        };

        allKeys.forEach((key) => {
            const beforeItem = before.find(
                (item) => item.name_title === key || item.name_id === key,
            );
            const afterItem = after.find(
                (item) => item.name_title === key || item.name_id === key,
            );

            const isDirectChange = isInChangedFields(
                beforeItem?.name_id || afterItem?.name_id,
            );

            if (!beforeItem && afterItem) {
                differences[key] = {
                    status: "added",
                    before: null,
                    after: afterItem,
                    isDirectChange: isDirectChange,
                };
            } else if (beforeItem && !afterItem) {
                differences[key] = {
                    status: "removed",
                    before: beforeItem,
                    after: null,
                    isDirectChange: isDirectChange,
                };
                // } else if (JSON.stringify(beforeItem) !== JSON.stringify(afterItem)) {
            } else if (!areObjectsEqual(beforeItem, afterItem)) {
                differences[key] = {
                    status: "modified",
                    before: beforeItem,
                    after: afterItem,
                    isDirectChange: isDirectChange,
                };
            }
        });

        return differences;
    };

    const differences = findDifferences(beforeData || [], afterData || []);

    const rowStatusMap = {};

    Object.entries(differences).forEach(([key, diff]) => {
        if (diff.status === "added") {
            rowStatusMap[key] = "created";
        } else if (diff.status === "removed") {
            rowStatusMap[key] = "deleted";
        } else if (diff.status === "modified") {
            rowStatusMap[key] = "updated";
        }
    });

    // Function to get hover tooltip text
    const getChangeReason = (itemKey, diff) => {
        // First check if it's in changed_fields
        const changedField = changeInfo?.changed_fields?.find(
            (field) => field.name === itemKey || field.name_id === itemKey,
        );

        if (changedField) {
            return `Direct Change: ${changedField.details || "Updated"}`;
        }

        // For cascade changes
        if (diff.status === "modified" && !diff.isDirectChange) {
            return "Cascade Change: Affected by other modifications";
        }

        return diff.status === "added" ? "Newly added item" : "Removed item";
    };

    if (!show) return null;

    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="sixth-seventh-modal"
            >
                <Modal.Header closeButton>
                    <div className="flex-row justify-between" style={{ width: "100%" }}>
                        <Modal.Title>Comparison View</Modal.Title>
                        <div className="salary-history-comparison-summary">
                            <h4 className="font-size-subheading">Summary of Changes:</h4>
                            <div className="salary-history-change-stats">
                                <div className="salary-history-stat-item">
                                    <span className="salary-history-stat-label">Added:</span>
                                    <span className="salary-history-stat-value">
                                        {
                                            Object.values(differences).filter(
                                                (d) => d.status === "added",
                                            ).length
                                        }
                                    </span>
                                </div>
                                <div className="salary-history-stat-item">
                                    <span className="salary-history-stat-label">Removed:</span>
                                    <span className="salary-history-stat-value">
                                        {
                                            Object.values(differences).filter(
                                                (d) => d.status === "removed",
                                            ).length
                                        }
                                    </span>
                                </div>
                                <div className="salary-history-stat-item">
                                    <span className="salary-history-stat-label">Modified:</span>
                                    <span className="salary-history-stat-value">
                                        {
                                            Object.values(differences).filter(
                                                (d) => d.status === "modified",
                                            ).length
                                        }
                                    </span>
                                </div>
                                {/* </div>
                            <div className="salary-history-change-stats"> */}
                                <div className="salary-history-stat-item">
                                    <span className="salary-history-stat-label">
                                        Direct Changes:
                                    </span>
                                    <span className="salary-history-stat-value">
                                        {
                                            Object.values(differences).filter((d) => d.isDirectChange)
                                                .length
                                        }
                                    </span>
                                </div>
                                <div className="salary-history-stat-item">
                                    <span className="salary-history-stat-label">
                                        Cascade Changes:
                                    </span>
                                    <span className="salary-history-stat-value">
                                        {
                                            Object.values(differences).filter(
                                                (d) => !d.isDirectChange,
                                            ).length
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <div className="salary-history-modal-body">
                    <div className="salary-history-comparison-container">
                        {/* <div className="salary-history-comparison-tables"> */}
                        <div className="flex-row">
                            <div className="salary-history-comparison-section">
                                <h4 className="salary-history-section-title">Before</h4>
                                <SalaryStructureTable
                                    salaryData={beforeData}
                                    content_type={"less"}
                                    scrollRef={leftColumnRef}
                                    handleScroll={handleScroll}
                                    rowStatusMap={rowStatusMap}
                                    tableSide="before"
                                />
                            </div>
                            <div className="salary-history-comparison-section">
                                <h4 className="salary-history-section-title">After</h4>
                                <SalaryStructureTable
                                    salaryData={afterData}
                                    content_type={"less"}
                                    scrollRef={rightColumnRef}
                                    handleScroll={handleScroll}
                                    rowStatusMap={rowStatusMap}
                                    tableSide="after"
                                />
                            </div>
                        </div>

                        <div className="salary-history-detailed-changes">
                            <h4 className="salary-history-section-title">
                                Detailed Changes:
                            </h4>
                            {Object.keys(differences).length > 0 ? (
                                <div className="salary-history-changes-list">
                                    {Object.entries(differences).map(([key, diff], idx) => {
                                        // Determine CSS class based on change type
                                        const statusClass = diff.isDirectChange
                                            ? `salary-history-change-${diff.status}`
                                            : `salary-history-change-${diff.status}-cascade`;
                                        return (
                                            <div
                                                key={idx}
                                                className={`salary-history-change-detail ${statusClass}`}
                                                title={getChangeReason(key, diff)} // Add hover tooltip
                                            >
                                                <div className="salary-history-change-header">
                                                    <strong>{key}</strong>
                                                    <div className="flex-row align-center gap-2">
                                                        <span
                                                            className={`status-badge ${diff.isDirectChange ? "color-badge-black" : " color-tab-grey"}`}
                                                        >
                                                            {diff.isDirectChange ? "Direct" : "Cascade"}
                                                        </span>
                                                        <span
                                                            className={`status-badge salary-history-status-${diff.status}`}
                                                        >
                                                            {diff.status}
                                                        </span>
                                                    </div>
                                                </div>
                                                {diff.status === "modified" && (
                                                    <div className="salary-history-change-details-grid">
                                                        <div className="salary-history-change-detail-item">
                                                            <strong>Before:</strong>
                                                            <div>
                                                                {diff.before.fixed_amount
                                                                    ? `₹${diff.before.fixed_amount}`
                                                                    : diff.before.percentage_of?.length
                                                                        ? `${diff.before.percentage}% of ${diff.before.percentage_of
                                                                            .map((item) => item.name_title)
                                                                            .join(", ")}`
                                                                        : `${diff.before.percentage}%`}
                                                            </div>
                                                            <div className="salary-history-change-amount">
                                                                <strong>Amount:</strong>
                                                                {renderAmount(diff.before)}
                                                            </div>
                                                        </div>
                                                        <div className="salary-history-change-detail-item">
                                                            <strong>After:</strong>
                                                            <div>
                                                                {diff.after.fixed_amount
                                                                    ? `₹${diff.after.fixed_amount}`
                                                                    : diff.after.percentage_of?.length
                                                                        ? `${diff.after.percentage}% of ${diff.after.percentage_of
                                                                            .map((item) => item.name_title)
                                                                            .join(", ")}`
                                                                        : `${diff.after.percentage}%`}
                                                            </div>
                                                            <div className="salary-history-change-amount">
                                                                <strong>Amount:</strong>
                                                                {renderAmount(diff.after)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {diff.status === "added" && (
                                                    <div className="salary-history-change-detail-item">
                                                        <strong>Added with:</strong>
                                                        <div>
                                                            {diff.after.fixed_amount
                                                                ? `₹${diff.after.fixed_amount}`
                                                                : diff.after.percentage_of?.length
                                                                    ? `${diff.after.percentage}% of ${diff.after.percentage_of
                                                                        .map((item) => item.name_title)
                                                                        .join(", ")}`
                                                                    : `${diff.after.percentage}%`}
                                                        </div>
                                                        <div className="salary-history-change-amount">
                                                            <strong>Amount:</strong>
                                                            {renderAmount(diff.after)}
                                                        </div>
                                                    </div>
                                                )}
                                                {diff.status === "removed" && (
                                                    <div className="salary-history-change-detail-item">
                                                        <strong>Removed:</strong>
                                                        <div>
                                                            {diff.before.fixed_amount
                                                                ? `₹${diff.before.fixed_amount}`
                                                                : diff.before.percentage_of?.length
                                                                    ? `${diff.before.percentage}% of ${diff.before.percentage_of
                                                                        .map((item) => item.name_title)
                                                                        .join(", ")}`
                                                                    : `${diff.before.percentage}%`}
                                                        </div>
                                                        <div className="salary-history-change-amount">
                                                            <strong>Amount:</strong>
                                                            {renderAmount(diff.before)}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <p className="salary-history-no-differences">
                                    No differences found
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

// ---------------------------
// 5. Main Salary History Component (Now handles both data types)
// ---------------------------
const SalaryHistoryTimeline = ({
    emp_code,
    employeeStatus = "active",
    dataType = "changes", // 'history' or 'changes'
    defaultStartPeriod = "",
    defaultEndPeriod = "",
}) => {
    const [buffer, setBuffering] = useState(false);
    const [startPeriod, setStartPeriod] = useState(defaultStartPeriod);
    const [endPeriod, setEndPeriod] = useState(defaultEndPeriod);
    const [salaryHistoryData, setSalaryHistoryData] = useState(null);
    const [subCompany, setSubCompany] = useState(
        sessionStorage.getItem("company_id"),
    );
    const [selectedDataType, setSelectedDataType] = useState(dataType);

    const fetchSalaryHistory = async (dataTypeToFetch = selectedDataType) => {
        setBuffering(true);
        try {
            const payload = {
                data_type: dataTypeToFetch,
                ...(startPeriod && {
                    start_period_month: parseInt(startPeriod.split("-")[1]),
                    start_period_year: parseInt(startPeriod.split("-")[0]),
                }),
                ...(endPeriod && {
                    end_period_month: parseInt(endPeriod.split("-")[1]),
                    end_period_year: parseInt(endPeriod.split("-")[0]),
                }),
            };

            const res = await axios.post(
                `${BASE_URL}/wfm/fetch-salaryhistorylog/${subCompany}/${employeeStatus}/${emp_code}/`,
                payload,
            );

            // Transform data based on data type
            const transformedData = transformDataForDisplay(
                res.data,
                dataTypeToFetch,
            );
            setSalaryHistoryData(transformedData);

            // // Update start period to joining date if available in response
            // if (res.data.employee && res.data.employee.joining_date) {
            //     const joiningMonthYear = formatDateForMonthInput(res.data.employee.joining_date);
            //     // Only update if start period is not already set
            //     if (!startPeriod) {
            //         setStartPeriod(joiningMonthYear);
            //     }
            // }
        } catch (err) {
            handleErrorToast(err);
            setSalaryHistoryData(null);
        } finally {
            setBuffering(false);
        }
    };

    // Helper function to transform data for consistent display
    const transformDataForDisplay = (data, dataType) => {
        if (!data) return null;

        // Clone the data to avoid mutations
        const transformed = { ...data };

        if (dataType === "changes") {
            // For changes data type, we might need to transform it to match history format
            if (transformed.salary_history) {
                transformed.salary_history = transformed.salary_history.map((item) => ({
                    ...item,
                    // Ensure consistent property names
                    wef_salary_data: item.wef_salary_data || [],
                    changes: item.changes || [],
                    // Handle missing properties for changes view
                    is_effective_month:
                        item.is_effective_month !== undefined
                            ? item.is_effective_month
                            : true,
                    applicable_of_months:
                        item.applicable_of_months || item.effective_period,
                }));
            }

            // Transform summary for changes view
            if (transformed.summary) {
                transformed.summary = {
                    ...transformed.summary,
                    effective_periods: transformed.summary.total_periods || 0,
                };
            }
        }

        return transformed;
    };

    const handleDataTypeChange = (type) => {
        setSelectedDataType(type);
        fetchSalaryHistory(type);
    };

    useEffect(() => {
        if (emp_code && startPeriod && endPeriod) {
            fetchSalaryHistory();
        }
    }, [emp_code, startPeriod, endPeriod, subCompany, employeeStatus]);

    const renderTimelineItem = (salaryItem, index) => {
        const {
            effective_period,
            is_active,
            is_effective_month,
            change_reason,
            updated_by_name,
            updated_at,
            wef_salary_data,
            changes = [],
            applicable_for_months = [],
        } = salaryItem;

        const hasChanges = changes && changes.length > 0;
        const changeCount = changes.length;
        const isChangesDataType = selectedDataType === "changes";

        return (
            <div
                key={`${effective_period}-${index}`}
                className="salary-history-timeline-item"
            >
                <div className="salary-history-timeline-dot"></div>
                <div className="salary-history-timeline-content">
                    <div className="salary-history-timeline-header">
                        <div className="salary-history-timeline-main">
                            <div className="salary-history-effective-period">
                                <h4 className="salary-history-period-title">
                                    {effective_period}
                                </h4>
                                <div className="salary-history-status-container">
                                    {/* <span className={`status-badge salary-history-status-${is_active ? 'active' : 'inactive'}`}> */}
                                    <span
                                        className={`priority-button ${is_active ? "color-tab-green" : "color-tab-grey"}`}
                                    >
                                        {is_active ? "Active" : "Inactive"}
                                    </span>
                                    {isChangesDataType && (
                                        <span
                                            className={`priority-button ${is_effective_month ? "color-tab-green" : "color-tab-grey"}`}
                                        >
                                            {/* <span className={`status-badge salary-history-status-${is_effective_month ? 'effective' : 'non-effective'}`}> */}
                                            {is_effective_month ? "Effective" : "Non-effective"}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="salary-history-timeline-meta">
                                <div className="salary-history-meta-item">
                                    <strong>Updated by:</strong> {updated_by_name || "N/A"}
                                </div>
                                <div className="salary-history-meta-item">
                                    <strong>Updated at:</strong>{" "}
                                    {updated_by_name && formatDate(updated_at, true).longdatetime}
                                </div>
                                {change_reason && (
                                    <div className="salary-history-meta-item">
                                        <strong>Reason:</strong> {change_reason}
                                    </div>
                                )}

                                {/* Applicable months for changes view */}
                                {isChangesDataType && applicable_for_months.length > 0 && (
                                    <div className="salary-history-applicable-months salary-history-meta-item flex-row">
                                        <strong>Applicable for:</strong>
                                        <div className="salary-history-applicable-list flex-row">
                                            {applicable_for_months.slice(0, 3).join(", ")}
                                            {applicable_for_months.length > 3 && (
                                                <div
                                                    className="salary-history-more-months"
                                                    title={applicable_for_months}
                                                >
                                                    +{applicable_for_months.length - 3} more
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div>
                            <div className="salary-history-timeline-actions">
                                {wef_salary_data && wef_salary_data.length > 0 ? (
                                    <SalaryDetailsModal
                                        salaryData={wef_salary_data}
                                        effectivePeriod={effective_period}
                                    />
                                ) : (
                                    <button
                                        style={{ cursor: "default" }}
                                        className="priority-button-small color-tab-grey"
                                    >
                                        No Salary
                                    </button>
                                )}

                                {hasChanges ? (
                                    <ChangeDetailsModal
                                        changeData={changes}
                                        effectivePeriod={effective_period}
                                        index={index}
                                    />
                                ) : (
                                    // <span className="salary-history-no-changes-badge">
                                    <button
                                        style={{ cursor: "default" }}
                                        className="priority-button-small color-tab-grey"
                                    >
                                        No changes
                                    </button>
                                )}

                                {/* {!hasChanges && (
                                    // <span className="salary-history-no-changes-badge">
                                    <button style={{ cursor: 'default' }} className="priority-button-small color-tab-grey">
                                        No changes
                                    </button>
                                )} */}
                            </div>
                            <div className="salary-history-timeline-meta">
                                <div className="salary-history-meta-item">
                                    <strong>Updated by:</strong> {updated_by_name || "N/A"}
                                </div>
                                <div className="salary-history-meta-item">
                                    <strong>Updated at:</strong>{" "}
                                    {updated_by_name && formatDate(updated_at, true).longdatetime}
                                </div>
                            </div>
                        </div>
                    </div>

                    {hasChanges && (
                        <div className="salary-history-change-summary">
                            <div className="salary-history-change-count">
                                {changeCount} change{changeCount > 1 ? "s" : ""} recorded
                            </div>
                            <div className="salary-history-change-preview">
                                {changes.slice(0, 2).map((change, idx) => (
                                    <div key={idx} className="salary-history-preview-item">
                                        <span className="salary-history-preview-reason">
                                            Reason : {change.change_reason}
                                        </span>
                                        <span className="salary-history-preview-date">
                                            {formatDate(change.change_date, true).longdatetime}
                                        </span>
                                    </div>
                                ))}
                                {changes.length > 2 && (
                                    <div className="salary-history-more-changes">
                                        +{changes.length - 2} more changes
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderSummaryCard = () => {
        if (!salaryHistoryData?.summary) return null;

        const { summary, request_period } = salaryHistoryData;
        const isChangesView = selectedDataType === "changes";

        return (
            <div className="salary-history-summary-card">
                <div className="salary-history-summary-header flex-row justify-between">
                    <h3 className="salary-history-summary-title">
                        {isChangesView ? "Changes Summary" : "Period Summary"}
                    </h3>
                    {request_period && (
                        <div className="salary-history-period-range">
                            {request_period.start} to {request_period.end}
                        </div>
                    )}
                </div>
                <div className="salary-history-summary-stats">
                    <div className="salary-history-stat-card">
                        <div className="salary-history-stat-value">
                            {summary.total_periods || 0}
                        </div>
                        <div className="salary-history-stat-label">
                            {isChangesView ? "Periods with Changes" : "Total Periods"}
                        </div>
                    </div>
                    {!isChangesView && (
                        <div className="salary-history-stat-card">
                            <div className="salary-history-stat-value">
                                {summary.effective_periods || 0}
                            </div>
                            <div className="salary-history-stat-label">Effective Periods</div>
                        </div>
                    )}
                    {summary.current_period && (
                        <div className="salary-history-stat-card">
                            {/* <div className="salary-history-stat-value">{summary.current_period}</div> */}
                            <div className="salary-history-stat-value">
                                {summary.effective_period || "-"}
                            </div>
                            <div className="salary-history-stat-label">
                                {summary.effective_period === summary.current_period
                                    ? "Current Period"
                                    : "Last Effective Period"}
                            </div>
                        </div>
                    )}
                </div>
                {summary.periods_without_changes?.length > 0 && (
                    <div className="salary-history-no-changes-periods">
                        <strong>
                            {isChangesView
                                ? "Periods without changes:"
                                : "Periods without changes:"}
                        </strong>{" "}
                        {summary.periods_without_changes.join(", ")}
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            <div className="salary-history-container">
                <div className="salary-history-header">
                    <div className="salary-history-header-top">
                        <h5 className="salary-history-title">Salary History Timeline</h5>

                        <div className="salary-history-data-type-toggle">
                            <button
                                className={`salary-history-data-type-btn ${selectedDataType === "history" ? "active" : ""}`}
                                onClick={() => handleDataTypeChange("history")}
                            >
                                Full History
                            </button>
                            <button
                                className={`salary-history-data-type-btn ${selectedDataType === "changes" ? "active" : ""}`}
                                onClick={() => handleDataTypeChange("changes")}
                            >
                                Changes Only
                            </button>
                        </div>
                    </div>

                    <div className="salary-history-filters align-center justify-center">
                        {/* <div className="salary-history-filter-group">
                            <label htmlFor="startPeriod" className="salary-history-filter-label">
                                Start Period
                            </label>
                            <input
                                type="month"
                                id="startPeriod"
                                value={startPeriod}
                                onChange={(e) => setStartPeriod(e.target.value)}
                                className="salary-history-filter-input"
                            />
                        </div>

                        <div className="salary-history-filter-group">
                            <label htmlFor="endPeriod" className="salary-history-filter-label">
                                End Period
                            </label>
                            <input
                                type="month"
                                id="endPeriod"
                                value={endPeriod}
                                onChange={(e) => setEndPeriod(e.target.value)}
                                className="salary-history-filter-input"
                            />
                        </div> */}

                        <label className="salary-history-filter-label">
                            Period Range :
                        </label>
                        <div className="salary-history-filter-group">
                            <MonthRangePicker
                                startDate={startPeriod}
                                endDate={endPeriod}
                                placeHolder1="Start Period"
                                placeHolder2="End Period"
                                onChange={(start, end) => {
                                    setStartPeriod(start);
                                    setEndPeriod(end);
                                }}
                            />
                        </div>
                        <div className="align-center">
                            <button
                                onClick={() => fetchSalaryHistory()}
                                className="priority-button model-button-print"
                            >
                                {salaryHistoryData && <Refresh />}{" "}
                                {salaryHistoryData ? "Filter" : "Apply Filter"}
                            </button>
                        </div>
                    </div>
                </div>

                {buffer ? (
                    <Loader container={true} />
                ) : salaryHistoryData ? (
                    <div className="salary-history-content">
                        {/* Employee Info Card */}
                        {/* {salaryHistoryData.employee && (
                            <div className="salary-history-employee-card">
                                <div className="salary-history-employee-header">
                                    <h3 className="salary-history-employee-title">Employee Information</h3>
                                    <div className="salary-history-data-type-indicator">
                                        Viewing: <strong>{selectedDataType === 'history' ? 'Full History' : 'Changes Only'}</strong>
                                    </div>
                                </div>
                                <div className="salary-history-employee-body">
                                    <div className="salary-history-info-row">
                                        <div className="salary-history-info-item">
                                            <strong>Name:</strong> {salaryHistoryData.employee.name}
                                        </div>
                                        <div className="salary-history-info-item">
                                            <strong>Employee Code:</strong> {salaryHistoryData.employee.emp_code}
                                        </div>
                                    </div>
                                    <div className="salary-history-info-row">
                                        <div className="salary-history-info-item">
                                            <strong>Department:</strong> {salaryHistoryData.employee.department_name}
                                        </div>
                                        <div className="salary-history-info-item">
                                            <strong>Designation:</strong> {salaryHistoryData.employee.designation_name}
                                        </div>
                                    </div>
                                    <div className="salary-history-info-row">
                                        <div className="salary-history-info-item">
                                            <strong>Joining Date:</strong> {salaryHistoryData.employee.joining_date}
                                        </div>
                                        <div className="salary-history-info-item">
                                            <strong>Status:</strong> {salaryHistoryData.employee.employee_status}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )} */}

                        {/* Summary Card */}
                        {renderSummaryCard()}

                        {/* Timeline */}
                        <div className="salary-history-timeline-wrapper">
                            {salaryHistoryData.salary_history &&
                                salaryHistoryData.salary_history.length > 0 ? (
                                salaryHistoryData.salary_history
                                    .filter((item) => {
                                        // For changes view, only show items with changes
                                        if (selectedDataType === "changes") {
                                            return item.changes?.length > 0;
                                        }
                                        // For history view, show all active items or items with changes
                                        // return item.is_active || item.changes?.length > 0;
                                        return true;
                                    })
                                    .sort((a, b) => {
                                        const dateA = new Date(
                                            `${a.wef_year}-${a.wef_month_num}-01`,
                                        );
                                        const dateB = new Date(
                                            `${b.wef_year}-${b.wef_month_num}-01`,
                                        );
                                        return dateB - dateA;
                                    })
                                    .map(renderTimelineItem)
                            ) : (
                                <div className="salary-history-empty">
                                    No{" "}
                                    {selectedDataType === "changes"
                                        ? "changes"
                                        : "salary history"}{" "}
                                    found for the selected period
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="salary-history-empty">
                        {startPeriod && endPeriod
                            ? "Unable to load salary history"
                            : "Select Period Range First"}
                    </div>
                )}
            </div>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

export {
    AttendanceDashboard,
    EmployeeDetailsChangeTimeline,
    BankDetailChangeLogDelete,
    SalaryStructureTable,
    SalaryHistoryTimeline,
};
